import { AdvancedFilterInputSchema } from "@redotech/redo-fulfillment-common/fulfillment-group-summary-input";
import { ShippingClaimSchema } from "@redotech/redo-package-protection-common/shipping-claims/shipping-claim";
import {
  OpensearchPaginationCursorSchema,
  PaginationCursorSchema,
} from "@redotech/redo-views-common/table";
import * as z from "zod";

export const getShippingClaims = {
  name: "getShippingClaims" as const,
  input: AdvancedFilterInputSchema.extend({
    pageNumber: z.number(),
    pageSize: z.number(),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    claims: z.array(ShippingClaimSchema),
    paginationCursor: PaginationCursorSchema.nullish(),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
